<script setup>
const props = defineProps({
  scenarios: { type: Array, default: () => [] },
  activeKey: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
  switchLabel: { type: String, default: 'Switch demo scenario' }
})

const emit = defineEmits(['select'])

const onTabsKeyDown = (event) => {
  if ((event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') || props.disabled) return
  event.preventDefault()
  const delta = event.key === 'ArrowRight' ? 1 : -1
  const idx = props.scenarios.findIndex((s) => s.key === props.activeKey)
  const next = props.scenarios[(idx + delta + props.scenarios.length) % props.scenarios.length]
  if (next) emit('select', next.key)
}
</script>

<template>
  <div class="call-tabs-row">
    <div
      class="call-tabs"
      role="tablist"
      :aria-label="switchLabel"
      @keydown="onTabsKeyDown"
    >
      <button
        v-for="scenario in scenarios"
        :key="scenario.key"
        class="call-tab"
        :class="{ active: scenario.key === activeKey }"
        role="tab"
        :aria-selected="scenario.key === activeKey"
        :disabled="disabled"
        @click="emit('select', scenario.key)"
      >
        {{ scenario.tab || scenario.brand }}
      </button>
    </div>
  </div>
</template>
